var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { BlockConfiguration } from "../../../data";
import { DeviceDetect } from "sb-resp-utils";
import { tickerDefaultConfig, tickerPopupDesktopConfigOverrides, tickerPopupMobileConfigOverrides } from "../components";
import { EventsManager } from "sb-js-extends";
export class JackpotDefaultBlockState {
    constructor(jackpot, cmsConfig, config) {
        this.deviceDetect = DeviceDetect.getInstance();
        this.tickerConfig = tickerDefaultConfig;
        this.jackpotBlockData = new BlockConfiguration(cmsConfig, jackpot);
        this.setBlockConfig(config);
        this.updateTimeZone(currentTimeZone);
        this.eventsManager = new EventsManager();
        this.eventsManager.addEventListener("timezoneSet", this, this.updateTimeZone, true);
        this.eventsManager.addEventListener("timezoneChanged", this, this.updateTimeZone, true);
    }
    updateTimeZone(newTime) {
        this.jackpotBlockData.updateTimeZone(Number(newTime));
    }
    setTickerConfig(forPopup) {
        if (forPopup) {
            this.tickerConfig = this.deviceDetect.isMobile ? tickerPopupMobileConfigOverrides : tickerPopupDesktopConfigOverrides;
        }
    }
    setBlockConfig(config) {
        if (config) {
            this.datePartConfig = config.datePartConfig;
            this.setTickerConfig(config.forPopup);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", BlockConfiguration)
], JackpotDefaultBlockState.prototype, "jackpotBlockData", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JackpotDefaultBlockState.prototype, "updateTimeZone", null);
//# sourceMappingURL=JackpotDefaultBlockState.js.map